<template>
  <div class="release">
    <el-dialog
      :visible="releaseType"
      width="67%"
      @close="handleClose">
      <span sloat="title" class="release-header">布置预习任务</span>
      <img class="release-img" src="../../images/release-success.png" alt="">
      <p class=""> 发 布 成 功 </p>
      <p id="text" style="top: 62%">学生可以登录学生账号后查看预习内容</p>
      <p id="text" style="top: 65%">老师可以在「备课中心-预习记录」中查看学生预习结果</p>
      <footer class="release-footer">
        <el-button plain style="color: #1989FA;" @click="examine"> 查 看 </el-button>
        <el-button type="primary" @click="getBack"> 返 回 </el-button>
      </footer>
    </el-dialog>
  </div>
</template>

<script>

export default {
  props: {
    releaseType: {
      required: true,
      default: false,
    },
  },
  methods: {
    handleClose() {
      this.getBack();
    },
    getBack() {
      this.$emit('getback', false);
    },
    examine() {
      this.$store.commit('changeActive', 'pre-record');
      this.getBack();
    },
  },
};
</script>

<style lang='scss' scoped>
  .release {
    position: relative;
    font-family: PingFangSC-Regular, PingFang SC;
    & /deep/ .el-dialog {
      height: 610px;
      padding-left: 50px;
      &__footer {
        float: left;
        position: relative;
        left: 108px;
      }
    }
    &-header {
      position: relative;
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      line-height: 33px;
      &::before {
        content: '';
        position: absolute;
        width: 3px;
        height: 16px;
        top: 10px;
        left: -30px;
        background: #1890FF;
        border-radius: 3px;
      }
      &::after {
        content: '';
        position: absolute;
        width: 143px;
        height: 13px;
        bottom: 5px;
        right: 0;
        background: rgba(230, 162, 60, 0.2);
        border-radius: 7px;
      }
    }
    &-img {
      position: absolute;
      left: 50%;
      top: 20%;
      transform: translateX(-50%);
    }
    p {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 56%;
      font-size: 22px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #02C387;
    }
    #text {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.6);
      line-height: 24px;
    }
    &-footer {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 80%;
      & /deep/ .el-button {
        width: 130px;
      }
    }
  }
</style>
